import { Box, Paper, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import TemplateBase from "../Generico/TemplateBase";
import FecharConta from "./components/compFecharConta";
import CompPedidos from "./components/compPedidos";

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tab-panel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

const Pedidos = () => {
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    document.title = "QR Pedir - Pedidos";
  }, []);

  const handleTabChange = (__, newValue) => {
    setTabValue(newValue);
  };

  return (
    <TemplateBase
      title="PEDIDOS"
      subTitle="Veja aqui os pedidos feitos em seu restaurante. Você também pode alterar o status de qualquer pedido"
    >
      <Paper sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab
              label="Lista"
              sx={{
                fontSize: "100%",
              }}
            />
            <Tab
              label="Contas abertas"
              sx={{
                fontSize: "100%",
              }}
            />
          </Tabs>
        </Box>
        <TabPanel value={tabValue} index={0}>
          <CompPedidos />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <FecharConta />
        </TabPanel>
      </Paper>
    </TemplateBase>
  );
};

export default Pedidos;
